export default "__VITE_ASSET__c39438f8__"